import { Component, OnInit, OnDestroy } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

import { DataService } from 'app/services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-toaster',
  templateUrl: './app-toaster.component.html',
  styleUrls: ['./app-toaster.component.scss'],
  animations: [
    trigger('animationOption2', [
      state(
        'close',
        style({
          display: 'none',
        })
      ),
      state(
        'open',
        style({
          display: 'block',
        })
      ),
      transition('close <=> open', animate(1000)),
    ]),
  ],
})
export class AppToasterComponent implements OnInit, OnDestroy {
  isVisible: boolean = false;
  timeout: any = '';
  message: any = {
    heading: '',
    body: '',
  };
  dataServiceSub: Subscription;
  status: string = '';

  constructor(private dataService: DataService) { }

  ngOnInit() {
    this.dataServiceSub = this.dataService.getData().subscribe(({ data }) => {
      if (data.type === 'app-toaster') {
        this.isVisible = true;
        this.message = data.message;
        this.status = data.status || 'error';

        this.timeout = setTimeout(() => {
          this.hideToaster();
        }, 4000);
      }
    });
  }

  ngOnDestroy() {
    if (this.dataServiceSub) this.dataServiceSub.unsubscribe();
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  hideToaster() {
    this.isVisible = false;
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  handleClick() {
    this.dataService.sendData(this.dataService.typePassData(this.message.event, {}));
  }

}
